(function() {
  if (typeof jsProduct === 'undefined') return;
  var variants = jsProduct.variants || [];
  if (!variants.length) return;
  var optionConfig = window.sbaSalesOptions || {};
  var sizeIndex = typeof optionConfig.sizeOptionIndex === 'number' ? optionConfig.sizeOptionIndex : 0;
  var colorIndex = typeof optionConfig.colorOptionIndex === 'number' ? optionConfig.colorOptionIndex : 1;
  var preferredSize = (optionConfig.preferredSize || 'M').toString();
  var addInFlight = false;
  var lastVariantUrl = '';
  var variantUrlTimer = null;

  function getSelectedSize() {
    var active = document.querySelector('.sba-sales-page .size-btn.active');
    return active ? active.dataset.size : '';
  }

  function getSelectedColor() {
    var active = document.querySelector('.sba-sales-page .color-swatch.active, .sba-sales-page .color-card.active');
    if (!active) return '';
    return active.title || active.dataset.color || '';
  }

  function getVariantOption(variant, index) {
    if (variant.options && variant.options[index]) return variant.options[index];
    return variant['option' + (index + 1)] || '';
  }

  function findVariant(size) {
    var color = getSelectedColor();
    var exactMatch = variants.find(function(v) {
      var sizeValue = getVariantOption(v, sizeIndex);
      var colorValue = getVariantOption(v, colorIndex);
      var sizeMatch = sizeValue && sizeValue.toUpperCase() === size.toUpperCase();
      var colorMatch = !color || !colorValue || colorValue.toLowerCase() === color.toLowerCase();
      return sizeMatch && colorMatch && v.available;
    });
    if (exactMatch) return exactMatch;

    return variants.find(function(v) {
      var sizeValue = getVariantOption(v, sizeIndex);
      return sizeValue && sizeValue.toUpperCase() === size.toUpperCase() && v.available;
    });
  }

  function getAvailableVariantForSize(size) {
    return findVariant(size);
  }

  function syncSizeAvailability() {
    var selectedSizeStillAvailable = false;
    var firstAvailable = null;
    var preferredAvailable = null;

    document.querySelectorAll('.sba-sales-page .size-btn').forEach(function(btn) {
      var size = btn.dataset.size || btn.textContent.trim();
      var variant = getAvailableVariantForSize(size);
      var available = !!variant;

      btn.classList.toggle('oos', !available);
      btn.classList.toggle('disabled', !available);
      btn.disabled = !available;
      btn.setAttribute('aria-disabled', String(!available));

      if (available && !firstAvailable) firstAvailable = btn;
      if (available && !preferredAvailable && size.toUpperCase() === preferredSize.toUpperCase()) preferredAvailable = btn;
      if (available && btn.classList.contains('active')) selectedSizeStillAvailable = true;
    });

    if (!selectedSizeStillAvailable && (preferredAvailable || firstAvailable)) {
      var fallback = preferredAvailable || firstAvailable;
      document.querySelectorAll('.sba-sales-page .size-btn').forEach(function(btn) {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
      });
      fallback.classList.add('active');
      fallback.setAttribute('aria-pressed', 'true');
    }
  }

  function getAddBtns() {
    var btns = document.querySelectorAll('.sba-sales-page [id$="AddToCart"], .sba-sales-page .cta-chrome, .sba-sales-page .sticky-bar-cta');
    var result = [];
    btns.forEach(function(b) {
      if (b.textContent.toLowerCase().includes('add to bag') || b.textContent.toLowerCase().includes('add to cart') || b.id.includes('AddToCart')) {
        result.push(b);
      }
    });
    return result;
  }

  function setButtonText(btn, text) {
    var label = btn.querySelector('[data-label], .sticky-label, .label');
    if (label) {
      label.dataset.label = text;
      label.textContent = text;
    } else {
      btn.textContent = text;
    }
  }

  function getButtonText(btn) {
    var label = btn.querySelector('[data-label], .sticky-label, .label');
    return label ? label.textContent : btn.textContent;
  }

  function setAddButtonsBusy(addBtns, busy) {
    addBtns.forEach(function(b) {
      if (busy) {
        b.dataset.inflight = 'true';
        b.setAttribute('aria-busy', 'true');
        b.setAttribute('aria-disabled', 'true');
        b.style.pointerEvents = 'none';
        b.style.opacity = '0.6';
      } else {
        delete b.dataset.inflight;
        b.removeAttribute('aria-busy');
        b.removeAttribute('aria-disabled');
        b.style.pointerEvents = '';
        b.style.opacity = '1';
      }
    });
  }

  function restoreAddButtons(addBtns) {
    (addBtns || getAddBtns()).forEach(function(b) {
      setButtonText(b, b.dataset.origText || 'Add To Cart');
      delete b.dataset.origText;
      delete b.dataset.sbaAtcError;
      b.removeAttribute('aria-disabled');
      b.style.pointerEvents = '';
      b.style.opacity = '1';
    });
  }

  function shakeSizeButtons() {
    document.querySelectorAll('.sba-sales-page .size-btn').forEach(function(b) {
      b.classList.add('shake');
      setTimeout(function() { b.classList.remove('shake'); }, 600);
    });
  }

  function getAddErrorText(error) {
    var message = error && error.message ? error.message : '';
    var normalized = message.toLowerCase();

    if (normalized.includes('cart') || normalized.includes('section')) return 'cart syncing';
    if (normalized.includes('sold out') || normalized.includes('unavailable')) return 'sold out';
    if (normalized.includes('quantity') || normalized.includes('maximum')) return 'limit reached';
    return 'try again';
  }

  function buildCartFormData(variant) {
    var formData = new FormData();
    formData.append('id', variant.id);
    formData.append('quantity', '1');
    return formData;
  }

  function fallbackAddToCart(formData) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    })
    .then(function(r) {
      return r.text().then(function(text) {
        var response;
        try {
          response = text ? JSON.parse(text) : {};
        } catch(e) {
          throw new Error('Cart temporarily unavailable');
        }
        if (!r.ok || response.status) throw new Error(response.description || response.message || 'Could not add item');
        return response;
      });
    })
    .then(function(response) {
      if (window.SBACart && typeof window.SBACart.open === 'function') window.SBACart.open();
      return response;
    });
  }

  function addToCart() {
    if (addInFlight) return;
    var size = getSelectedSize();
    if (!size) {
      shakeSizeButtons();
      return;
    }
    var variant = findVariant(size);
    if (!variant) {
      var soldOutBtns = getAddBtns();
      soldOutBtns.forEach(function(b) {
        if (!b.dataset.origText) b.dataset.origText = getButtonText(b);
        setButtonText(b, 'sold out');
        b.setAttribute('aria-disabled', 'true');
        b.style.pointerEvents = 'none';
        b.style.opacity = '0.6';
      });
      return;
    }

    var addBtns = getAddBtns();
    addInFlight = true;
    addBtns.forEach(function(b) {
      if (!b.dataset.origText) b.dataset.origText = getButtonText(b);
      setButtonText(b, 'adding...');
    });
    setAddButtonsBusy(addBtns, true);

    var formData = buildCartFormData(variant);
    var addPromise = window.SBACart && typeof window.SBACart.add === 'function'
      ? window.SBACart.add(formData, {
          trigger: addBtns[0],
          source: 'sba-pdp',
          detail: { product: jsProduct, variant: variant }
        })
      : fallbackAddToCart(formData);

    addPromise
    .then(function(item) {
      addBtns.forEach(function(b) {
        b.style.opacity = '1';
        setButtonText(b, 'added');
      });
      setTimeout(function() {
        restoreAddButtons(addBtns);
      }, 2000);
      if (window.CandyRack) try { window.CandyRack.onItemAdded(item); } catch(e) {}
    })
    .catch(function(error) {
      var errorText = getAddErrorText(error);
      addBtns.forEach(function(b) {
        b.style.opacity = '1';
        b.dataset.sbaAtcError = error && error.message ? error.message : errorText;
        setButtonText(b, errorText);
      });
      setTimeout(function() {
        restoreAddButtons(addBtns);
      }, 2000);
    })
    .finally(function() {
      addInFlight = false;
      setAddButtonsBusy(addBtns, false);
    });
  }

  function bindMobileStickyAtc() {
    document.querySelectorAll('.sba-sales-page .mobile-sticky-atc, .sba-sales-page #mobileStickyAtc').forEach(function(btn) {
      if (btn.dataset.sbaStickyAtcBound === 'true') return;
      btn.dataset.sbaStickyAtcBound = 'true';
      btn.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var primary = document.querySelector('.sba-sales-page #heroAddToCart') || getAddBtns()[0];
        if (primary && primary !== btn) {
          primary.click();
          return;
        }

        addToCart();
      }, true);
    });
  }

  function updateUrlVariant(size) {
    var variant = findVariant(size);
    if (!variant || !window.history || !window.URLSearchParams) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    var nextUrl = url.toString();
    if (nextUrl === lastVariantUrl) return;
    window.clearTimeout(variantUrlTimer);
    variantUrlTimer = window.setTimeout(function() {
      window.history.replaceState({}, '', nextUrl);
      lastVariantUrl = nextUrl;
    }, 120);
  }

  function bindSalesAtc() {
    syncSizeAvailability();

    if (!document.querySelector('.sba-sales-page .size-btn.active')) {
      var preferred = document.querySelector('.sba-sales-page .size-btn:not(.oos):not(.disabled):not([disabled])[data-size="' + preferredSize.replace(/"/g, '\\"') + '"]');
      var first = preferred || document.querySelector('.sba-sales-page .size-btn:not(.oos):not(.disabled):not([disabled])');
      if (first) {
        first.classList.add('active');
        first.setAttribute('aria-pressed', 'true');
      }
    }

    document.querySelectorAll('.sba-sales-page [id$="AddToCart"], .sba-sales-page .cta-chrome, .sba-sales-page .sticky-bar-cta').forEach(function(btn) {
      if (btn.dataset.sbaAtcBound === 'true') return;
      if (btn.textContent.toLowerCase().includes('add to bag') || btn.textContent.toLowerCase().includes('add to cart') || btn.id.includes('AddToCart')) {
        btn.dataset.sbaAtcBound = 'true';
        btn.removeAttribute('href');
        btn.style.cursor = 'pointer';
        btn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); addToCart(); });
      }
    });

    document.querySelectorAll('.sba-sales-page .size-btn:not(.oos):not(.disabled):not([disabled])').forEach(function(btn) {
      if (btn.dataset.sbaSizeBound === 'true') return;
      btn.dataset.sbaSizeBound = 'true';
      btn.addEventListener('click', function() {
        restoreAddButtons();
        updateUrlVariant(btn.dataset.size || '');
      });
    });

    bindMobileStickyAtc();
  }

  bindSalesAtc();
  document.addEventListener('shopify:section:load', bindSalesAtc);
})();

(function() {
  var page = document.querySelector('.sba-sales-page');
  if (!page) return;

  var tracks = Array.prototype.slice.call(page.querySelectorAll('.gallery-track'));
  if (!tracks.length) return;

  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 1023px)') : { matches: true };

  function getSource(img) {
    return img.currentSrc || img.src || (img.dataset && (img.dataset.src || img.dataset.original)) || '';
  }

  function primeImage(img, highPriority) {
    if (!img) return;
    img.loading = 'eager';
    img.setAttribute('loading', 'eager');
    if (!img.decoding) img.decoding = 'async';
    if ('fetchPriority' in img) img.fetchPriority = highPriority ? 'high' : 'auto';

    if (img.dataset.sbaPrimed === 'true') {
      if (img.decode) img.decode().catch(function() {});
      return;
    }
    img.dataset.sbaPrimed = 'true';

    var source = getSource(img);
    if (!source) return;

    var preload = new Image();
    preload.decoding = 'async';
    if (img.sizes) preload.sizes = img.sizes;
    if (img.srcset) preload.srcset = img.srcset;
    preload.src = source;
    if (preload.decode) preload.decode().catch(function() {});
    if (img.decode) img.decode().catch(function() {});
  }

  function getIndex(track) {
    var active = track.style.getPropertyValue('--active-slide');
    var parsed = parseInt(active, 10);
    if (!Number.isNaN(parsed)) return parsed;
    if (track.clientWidth) return Math.round(track.scrollLeft / track.clientWidth);
    return 0;
  }

  function primeAround(track, index, radius) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.gallery-slide'));
    var start = Math.max(0, index - radius);
    var end = Math.min(slides.length - 1, index + radius);
    for (var i = start; i <= end; i += 1) {
      var img = slides[i] && slides[i].querySelector('img');
      primeImage(img, i <= 1);
    }
  }

  tracks.forEach(function(track) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.gallery-slide'));
    var mobileRadius = Math.max(2, slides.length);
    primeAround(track, 0, mobileQuery.matches ? mobileRadius : 1);

    var primeNext = function() {
      primeAround(track, getIndex(track), mobileQuery.matches ? mobileRadius : 2);
    };

    track.addEventListener('touchstart', primeNext, { passive: true });
    track.addEventListener('pointerdown', primeNext, { passive: true });
    track.addEventListener('scroll', function() {
      window.requestAnimationFrame(primeNext);
    }, { passive: true });
  });
})();

(function() {
  var page = document.querySelector('.sba-sales-page');
  if (!page) return;

  function imageDrawerIsOpen() {
    return !!document.querySelector('.image-drawer.open, .image-drawer.is-open, [data-image-drawer].open, [data-image-drawer].is-open, .product-image-drawer.open, .product-image-drawer.is-open');
  }

  function releaseGalleryLockForAccordion() {
    if (imageDrawerIsOpen()) return;
    document.body.classList.remove('gallery-locked');
    document.documentElement.classList.remove('gallery-locked');
  }

  page.addEventListener('click', function(event) {
    if (!event.target.closest('.product-accordion-trigger')) return;
    window.requestAnimationFrame(releaseGalleryLockForAccordion);
    window.setTimeout(releaseGalleryLockForAccordion, 80);
  }, true);

  page.addEventListener('touchstart', function(event) {
    if (event.target.closest('.product-accordion')) releaseGalleryLockForAccordion();
  }, { passive: true, capture: true });

  page.addEventListener('touchmove', function(event) {
    if (event.target.closest('.product-accordion')) releaseGalleryLockForAccordion();
  }, { passive: true, capture: true });

  document.addEventListener('shopify:section:load', releaseGalleryLockForAccordion);
  window.addEventListener('pageshow', releaseGalleryLockForAccordion);
})();
